var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('br'),_c('div',[_c('br'),_c('b-img',{attrs:{"fluid":"","src":require('../assets/LogoLG.png')}})],1),_c('br'),_c('br'),_c('h1',{staticClass:"text-primary"},[_vm._v(_vm._s(_vm.msg))])])}
var staticRenderFns = []

export { render, staticRenderFns }